import React, { FC } from 'react';
import { Box, makeStyles, Typography } from '@dxb-web-ui-framework/design-system';
import { useTranslation } from 'react-i18next';
import ecommbxLandingPageLogo from '../../../../../../../../src/channels/public-web/assets/newEcommbxLandingPageLogo.svg';

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  publicAppPageContainer: {
    [breakpoints.down('md')]: {
      flexDirection: 'column-reverse',
    },
  },
  image: {
    height: '370px',
    paddingLeft: spacing(4),
    [breakpoints.down('md')]: {
      paddingLeft: 0,
    },
  },
}));
const PublicSplitScreen: FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Box display={'flex'} alignItems={'center'} className={classes.publicAppPageContainer}>
      <Box>
        <Typography variant={'h3'} component={'h2'} color={'secondary'}>
          {t('landingPage.screenSplitLayout.Main.LeftContainer.TitleFirstLine')} <br />
          <Typography variant='h2' component={'span'} color={'primary'}>
            {t('landingPage.screenSplitLayout.Main.LeftContainer.TitleSecondLine')}
          </Typography>
        </Typography>
      </Box>
      <Box>
        <img
          className={classes.image}
          src={ecommbxLandingPageLogo}
          alt={t('screenSplitLayout.Main.LeftContainer.SpartanCosmos.ImgAlt')}
        />
      </Box>
    </Box>
  );
};

export { PublicSplitScreen };
